import { api } from './api'

export interface LegacyUserRoles {
  sid: string
  dashboardSi: boolean
  [role: string]: boolean | string | null | undefined
}

function toBoolean(value: unknown): boolean {
  if (typeof value === 'boolean') return value
  if (typeof value === 'number') return value === 1
  if (typeof value === 'string') {
    return ['true', '1', 'yes', 'y'].includes(value.trim().toLowerCase())
  }
  return false
}

function normalizeLegacyUserRoles(response: Record<string, unknown>): LegacyUserRoles {
  return {
    ...response,
    sid: String(response.sid ?? response.Sid ?? ''),
    dashboardSi: toBoolean(response.dashboardSi ?? response.DashboardSi),
  } as LegacyUserRoles
}

export const legacyUserRoleService = {
  getUserRoles: async (sid: string): Promise<LegacyUserRoles> => {
    const response = await api.get<Record<string, unknown>>(
      `/legacydb/escworksuserroles/${encodeURIComponent(sid)}`,
    )

    return normalizeLegacyUserRoles(response)
  },
}
